import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * getShareId
   */
  static getShareId(data) {
    return Request({
      url: 'visitor/share/record/share',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      ignore401: true,
      data
    });
  }
  /**
   * 查询资格购活动列表
   */
  static getQualificationList(data) {
    return Request({
      url: 'promotion/queryActiveActivity/qualification/validate',
      host: config.HOST_MALL,
      method: 'post_json',
      ignore401: true,
      data
    });
  }
  /**
   * 根据商品id获取商品详情
   */
  static getProductDetail(id, type) {
    if (!id) {
      return Promise.reject(new Error('id不能为空'));
    }
    let url = `item/biz/ext/get/${id}`;
    switch (+type) {
      case 2:
        url = `item/bundle/ext/get/${id}`;
        break;
      case 3:
        url = `item/bundle/ext/get/${id}`;
        break;
      case 5:
        url = `item/specs/ext/get/${id}`;
        break;
      case 7:
        url = `bean/item/detail?beanItemId=${id}`;
        break;
      case 8:
        url = `priaPoints/item/queryByItemId?itemId=${id}`;
        break;
      default:
        url = `item/biz/ext/get/${id}`;
        break;
    }
    return Request({
      url,
      host: config.HOST_MALL,
      ignoreErr: true
    });
  }

  static getProductSellPoint(id) {
    return Request({
      url: `item/sell/point/${id}`,
      host: config.HOST_MALL,
      method: 'get',
      ignoreErr: true
    });
  }

  /**
   * 根据商品id查询问答
   */
  static getQuestionList(id) {
    return Request({
      url: `item/biz/detail/question/${id}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }
  /**
   * 根据商品id查询评价
   */
  static getEvaluateList(id) {
    return Request({
      url: `item/queryPage/evaluate/byItem?itemCode=${id}&pageNum=${1}&pageSize=3`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }
  /**
   * 浏览足迹
   */
  static addFootPrint(id) {
    return Request({
      url: 'user/browseFootprint/add',
      host: config.HOST_MALL,
      method: 'post_json',
      data: { itemId: id }
    });
  }

  /**
   * 获取库存信息
   */
  static getInventory(params) {
    return Request({
      url: `item/inventory/sku`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 获取推荐列表
   */
  static getRecommendList(itemId) {
    return Request({
      url: `item/query/recommend-item-list/${itemId}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 查询是否已收藏
   */
  static checkIsCollected(itemId, activityId = '') {
    let url = `user/collection/collection/queryItemCollectedOrNot/${itemId}`;
    activityId && (url += `?activeId=${activityId}`);
    return Request({
      url,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  // 获取推荐文章列表
  static getRecommendArticleList(params, data) {
    return Request({
      url: 'content/query/itemRefContent',
      host: config.HOST_PROMOTE,
      method: 'post_json',
      params,
      data
    });
  }
  /**
   * 获取推荐组合产品
   */
  static getRecommendBundles(itemCode) {
    return Request({
      url: `item/query/recommend/bundle-item-list/${itemCode}`,
      host: config.HOST_MALL
    });
  }
  /**
   * getBannerDetails
   */
  static getBannerDetails(id) {
    return Request({
      url: `item/query/recommend/position/${id}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  static queryCanApplyType(params) {
    return Request({
      url: 'user/register/checkOpenCardAttribute',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询产品搜索优化信息
   */
  static getSearchOpt(itemCode) {
    return Request({
      url: `item/query/search-optimization/info/${itemCode}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 查询当前商品可参与的促销活动列表信息
   */
  static getPromoteInfo(itemId, source, activityId, globalSaleMode = '') {
    let u = '';
    if (activityId) {
      u = `tradecore/promotion/item/detail/activity-info/${itemId}?shareActivityId=${activityId}&saleMode=${globalSaleMode || ''}`;
    } else {
      u = `tradecore/promotion/item/detail/activity-info/${itemId}?saleMode=${globalSaleMode || ''}`;
    }

    return Request({
      // source=${source}&
      url: u,
      host: config.HOST_MALL
    });
  }

  /**
   * 三生豆查询当前商品可参与的促销活动列表信息
   */
  static getBeanPromoteInfo(itemId, globalSaleMode) {
    return Request({
      url: `bean/item/detail/activity-info/${itemId}?saleMode=${globalSaleMode || ''}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 查询当前商品可参与的促销活动列表信息（根据订单类型、配送比例）
   */
  static getActivityList(params) {
    return Request({
      url: `tradecore/trolley/activity/switch/list`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }

  static getBlackItemActivityIdList(itemId) {
    return Request({
      url: `item/biz/getBlackItemActivityIdList/${itemId}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 查询秒杀拼团预售活动信息
   */
  static getActivityInfo(activityId, itemId) {
    return Request({
      url: `promotion/${activityId}/${itemId}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  /**
   * 查询对应活动id的赠品列表
   */
  static getActivityGiftList(params) {
    return Request({
      url: `tradecore/promotion/activity/gift/list`,
      host: config.HOST_MALL,
      params
    });
  }

  /**
   * 查询对应活动ids的赠品列表 废弃的接口
   */
  static getActivityIdsGiftList(params) {
    if (params.activityIds) {
      return Request({
        url: `tradecore/promotion/activity/gift/multi/list`,
        host: config.HOST_MALL,
        params
      });
    }
  }
  /**
   * 查询对应活动ids的赠品列表 满赠阶梯的
   */
  static getJTActivityIdsGiftList(params) {
    return Request({
      url: `tradecore/promotion/activity/gift/list/preferential`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  /**
   * 秒杀  赠品列表
   */
  static getActivityIdsGiftListForSeckill(data) {
    // if (params.activityIds) {
    return Request({
      url: `tradecore/promotion/activity/gift/thresholdById`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
    // }
  }

  /**
   * 查询拼团活动id的成团信息
   */
  static getActivityGroupList(data) {
    return Request({
      url: `item/biz/ext/group/activity`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 查询对应活动id的加价购列表
   */
  static getActivityIncPriceList(data) {
    return Request({
      url: `tradecore/trolley/activity/additional/item/list`,
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 拼团预售校验
   * 预售-支付尾款阶段时校验是否支付定金
   * 拼团-是否有当前商品的未成功的拼团
   */
  static checkCanBuy(params) {
    let { type, activityId, itemId } = params;
    return Request({
      url: `biz/tradecore/trade/confirmGroupSale/${type}/activity/${activityId}/item/${itemId}/tradeNo`,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 拼团参团校验
   */
  static checkCanJoin(groupOrderId) {
    return Request({
      url: `biz/tradecore/trade/judgeGroupSale/${groupOrderId}`,
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 获取活动信息
   */
  static getActivityDetail(activityId) {
    return Request({
      url: `promotion/activity/id/${activityId}`,
      host: config.HOST_MALL,
      method: 'get'
    });
  }

  static getTitleName(subActivityId) {
    return Request({
      url: `promotion/query/subActivity?subActivityId=${subActivityId}`,
      host: config.HOST_MALL
    });
  }

  // 上报名片访问商品
  static addViewItem(params) {
    return Request({
      url: `content/card/statistics/add/view/item`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
  /**
   * 查询对应活动id的赠品列表
   */
  static getDistributionTip(params) {
    return Request({
      url: `trade/queryOrderProperty`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 查询是否绑定过微信
   */
  static queryBindFlag() {
    return Request({
      url: 'user/binding/query/bindFlag',
      host: config.HOST_MALL,
      method: 'post_json'
    });
  }

  /**
   * 获取跳转链接
   */
  static getWechatLoginUrl(params) {
    return Request({
      url: 'user/login/wechatLoginUrl',
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 查询甄选购物车商品数量
  static querySelectMallCartNum() {
    return Request({
      url: 'tradecore/integral/trolley/item/count/0',
      host: config.HOST_MALL
    });
  }
  // 通过产品id查多规格商品详情
  static getMoreMultiList(itemCode) {
    return Request({
      url: `item/biz/ext/get/${itemCode}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 日常任务列表
   */
  static queryTaskList() {
    return Request({
      url: `progress/clock/personal/queryTaskListInfoPage`,
      host: config.HOST_PROMOTE,
      method: 'get',
      params: { pageNum: 1, pageSize: 10 }
    });
  }

  /**
   * 上报打卡任务
   */
  static finishTaskReport(params) {
    return Request({
      url: `progress/clock/personal/finishTask`,
      host: config.HOST_PROMOTE,
      method: 'post',
      params,
      ignoreErr: true
    });
  }

  /**
   * 获取用权限点
   */
  static getGongSiEnterList() {
    return Request({
      url: `user/info/getGongSiEnterList`,
      host: config.HOST_MALL,
      method: 'GET'
    });
  }

  /**
   * 获取用权限点
   */
  static getEnterList() {
    return Request({
      url: `user/info/getEnterList`,
      host: config.HOST_MALL
    });
  }

  static getLogistics(params) {
    return new Promise((resolve) => {
      Request({
        url: `biz/tradecore/trade/get-by-logistics`,
        host: config.HOST_MALL
      }).then((res) => {
        const obj = res.data.deliveryAddressMap || {};
        let defaultAddress = null;
        Object.keys(obj).forEach((key) => {
          if (obj[key].defaultAddress) {
            defaultAddress = obj[key];
            defaultAddress.id = defaultAddress.userAddressId;
            defaultAddress.status = 1;
            defaultAddress.province = defaultAddress.provinceName;
            defaultAddress.city = defaultAddress.cityName;
            defaultAddress.district = defaultAddress.areaName;
            defaultAddress.street = defaultAddress.streetName;
            defaultAddress.districtCode = defaultAddress.areaCode;
            defaultAddress.contact = defaultAddress.deliveryName;
            defaultAddress.phone = defaultAddress.deliveryMobile;
            defaultAddress.detailAddr = [
              defaultAddress.provinceName,
              defaultAddress.cityName,
              defaultAddress.areaName,
              defaultAddress.streetName,
              defaultAddress.address
            ]
              .filter((e) => e)
              .join('/');
          }
        });
        if (defaultAddress) {
          resolve({ data: { list: [defaultAddress], pageNum: 1, pages: 1 } });
        } else {
          resolve({ data: { list: [], pageNum: 1, pages: 1 } });
        }
      });
    });
  }

  // 获取地址列表
  static getAddressList() {
    return Request({
      url: `tradecore/member/address/queryByPage`,
      host: config.HOST_MALL,
      params: {
        pageSize: 4,
        pageNum: 1
      }
    });
  }

  /**
   * 获取运费
   */
  static getFreight(data) {
    return Request({
      url: 'biz/tradecore/trade/calculate/freight/remind',
      host: config.HOST_MALL,
      method: 'post_json',
      data
    });
  }

  /**
   * 宫主会查询当前商品可参与的促销活动列表信息
   */
  static getPriaPromoteInfo(itemId, globalSaleMode) {
    return Request({
      url: `priaPoints/item/detail/activity-info/${itemId}?saleMode=${globalSaleMode || ''}`,
      host: config.HOST_MALL
    });
  }

  /**
   * 宫主会查询购物车数量
   */
  static getPriaCount() {
    return Request({
      url: `tradecore/priaPoints/trolley/item/count/2`,
      host: config.HOST_MALL
    });
  }

  /**
   * 加入宫主会购物车
   */
  static addPriaCart(params) {
    return Request({
      url: `tradecore/priaPoints/trolley/item/add/2`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  // 校验是否是优享会商品且有无分销权限
  static checkActivity(params) {
    return Request({
      url: `trade/yxh/distribution/checkActivity`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/ProductDetail/ProductDetailServ.js